import React, { useEffect } from "react";
import { AutocompleteAddressHeadless } from "../../../../AutocompleteAddressHeadless/AutocompleteAddressHeadless";
import {
  Box,
  Button,
  TextField,
  Typography,
  useTheme,
} from "@material-ui/core";
import Text from "../../../../../../../shared/components/Text";
import { ENV_MAPS_API_KEY } from "../../../../../../../../config/envVars";
import { EditAddress } from "./EditAddress";
import { AddressFormResetValues } from "../../../../AutocompleteAddressHeadless/constants/AddressFormResetValues";
import { MANUAL_OPTION_VALUE } from "../../../../AutocompleteAddressHeadless/components/GoogleMapsAutocomplete/GoogleMapsAutocomplete";

export const AddressForm = ({ formMethods, edit, setEdit }) => {
  const watch = formMethods.watch;
  const errors = formMethods.errors?.address;
  const reset = formMethods.reset;
  const address = watch("address.address");
  const { palette, customBorderRadius } = useTheme();

  useEffect(() => {
    if (errors || address === MANUAL_OPTION_VALUE) {
      setEdit(true);
    }
  }, [errors, address]);

  return (
    <>
      <AutocompleteAddressHeadless.Address
        apiKey={ENV_MAPS_API_KEY}
        hidden={address}
      />
      {address && !edit && (
        <>
          <Box
            display={"flex"}
            flexDirection={"column"}
            border={`1px solid ${palette.grey[300]}`}
            borderRadius={customBorderRadius.paper}
            p={2}
            gridGap={10}
          >
            <Typography variant="body2">
              <Text tId={"SELECTED_ADDRESS"} />:
            </Typography>
            <Box
              display={"flex"}
              flexDirection={"row"}
              justifyContent={"flex-start"}
              alignItems={"self-start"}
              gridGap={6}
            >
              <i
                className="material-icons-outlined"
                style={{ color: palette.success.main, fontSize: "20px" }}
              >
                check
              </i>
              <Typography variant={"body1"} color="textPrimary">
                <strong>{address}</strong>
              </Typography>
            </Box>
            <Box
              display={"flex"}
              flexDirection={"row"}
              gridGap={6}
              justifyContent={"flex-end"}
            >
              <Button
                size="small"
                onClick={() => {
                  setEdit(false);
                  reset(AddressFormResetValues);
                }}
              >
                <i
                  className="material-icons-outlined"
                  style={{ fontSize: "18px", marginRight: "4px" }}
                >
                  room
                </i>
                <Text style={{ fontSize: "18px" }} tId={"SEARCH_AGAIN"} />
              </Button>
              <Button
                size="small"
                variant="outlined"
                onClick={() => setEdit(!edit)}
              >
                <i
                  className="material-icons-outlined"
                  style={{ fontSize: "18px", marginRight: "4px" }}
                >
                  edit
                </i>
                <Text style={{ fontSize: "18px" }} tId={"EDIT"} />
              </Button>
            </Box>
          </Box>
        </>
      )}
      <EditAddress formMethods={formMethods} edit={edit} />
      <AutocompleteAddressHeadless.HiddenField
        name={"address.province"}
        as={<TextField />}
      />
      <AutocompleteAddressHeadless.HiddenField
        name={"address.provinceShortName"}
        as={<TextField />}
      />
      <AutocompleteAddressHeadless.HiddenField
        name={"address.region"}
        as={<TextField />}
      />
      <AutocompleteAddressHeadless.HiddenField
        name={"address.regionShortName"}
        as={<TextField />}
      />
      <AutocompleteAddressHeadless.HiddenField
        name={"address.latitude"}
        as={<TextField />}
      />
      <AutocompleteAddressHeadless.HiddenField
        name={"address.longitude"}
        as={<TextField />}
      />
      <AutocompleteAddressHeadless.HiddenField
        name={"address.countryLongName"}
        as={<TextField />}
      />
    </>
  );
};
